import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getEditZoneCoordinates = createAsyncThunk('zone/getEditZoneCoordinates ', async (params) => {
  
  const response = await axios.post('https://api.zasway.com:8443/Zone/GetTableSummaryZones', params, { mode: 'cors' })
  
  return {data : response.data}
})
export const displayZoneCoordinates = createAsyncThunk('zone/displayZoneCoordinates ', async (params) => {
  
  const response = await axios.post('https://api.zasway.com:8443/Zone/GetTableSummaryZones', params, { mode: 'cors' })
  
  return {data : response.data}
})

export const displayZoneCoordinatesAll = createAsyncThunk('zone/displayZoneCoordinatesAll ', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Zone/GetTableSummaryZones', params, { mode: 'cors' })
  return {data : response.data}
})

export const getZoneCoordinatesOnEdit = createAsyncThunk('/zone/getZoneCoordinatesOnEdit',  (getZoneCoordinates) => {
  
return {data : getZoneCoordinates}
}) 
export const modalClose = createAsyncThunk('/zone/modalClose',  (modalClosed) => {
  
return {data : modalClosed}
}) 
export const getZoneCoordinates = createAsyncThunk('/zone/getZoneCoordinates',  (getZoneCoordinates) => {
     
  return {data : getZoneCoordinates.zoneCoordinates}
  })
export const getData = createAsyncThunk('zone/getData', async (params) => {
          
const response = await axios.post('https://api.zasway.com:8443/Zone/GetZone', params, {mode:'cors'})
 
    return {
      params,
      data: response.data.data,
      allData: response.data.allData,
      totalPages: response.data.total
    }
})

export const getZone = createAsyncThunk('zone/getZone', async (params) => {
     
  const response = await axios.post('https://api.zasway.com:8443/Zone/GetZone', params, {mode:'cors'})
    
  return {
    params,
    data: response.data.data,
    allData: response.data.allData,
    totalPages: response.data.total
  }
})

export const getZoneList = createAsyncThunk('zone/getZoneList', async (params) => {
      
  const response = await axios.post('https://api.zasway.com:8443/Zone/GetZone', params, {mode:'cors'})
  return response.data
})

export const getAllZonePostCode = createAsyncThunk('zone/getAllZonePostCode', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Zone/GetAllZonePostCode', params, {mode:'cors'})
  return response.data
})

export const getPostCodeLatLong = createAsyncThunk('zone/GetPostCodeLatLong', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Zone/GetPostCodeLatLong', params, {mode:'cors'})
  return response.data
})

export const addZone = createAsyncThunk('zone/Create',  async (Zone) => {
  
  const response = await axios.post('https://api.zasway.com:8443/Zone/Create', Zone, {mode:'cors'})
  
return response
})

export const editZone  = createAsyncThunk('zone/editZone', async (Zone) => {
     
  const response = await axios.post('https://api.zasway.com:8443/Zone/Update', Zone, {mode:'cors'})
  
  return response
})

export const getZoneTag = createAsyncThunk('zone/getZoneTag', async (params) => {
   
const response = await axios.post('https://api.zasway.com:8443/Zone/GetZone', params, {mode:'cors'})
 
return {
 params,
 data: response.data.data, 
 allData: response.data.allData,
 totalPages: response.data.total
}
})

export const getZoneEditData = createAsyncThunk('zone/getZoneEditData', async (params) => {   
   
  const response = await axios.post('https://api.zasway.com:8443/Zone/GetZone', params, {mode:'cors'})
  
  return {data:response.data}
})

export const getPostcodeZoneEditData = createAsyncThunk('zone/getPostcodeZoneEditData', async (params) => {   
   
  const response = await axios.post('https://api.zasway.com:8443/Zone/GetZoneEditData', params, {mode:'cors'})
  
  return {data:response.data}
})

export const deleteZone = createAsyncThunk('zone/Delete', async (id, { dispatch, getState }) => {
   
  const response = await axios.post('https://api.zasway.com:8443/Zone/Delete', id, {mode:'cors'})
   
  await dispatch(getData(getState().zone.params))
  
  return response
})

export const resetZoneEditData = createAsyncThunk('zone/resetZoneEditData', async () => {
     
   return {data:[]}
 })

// export const deleteZone = createAsyncThunk('zone/Delete', async (id, { dispatch, getState }) => {
//    
//   const response = await axios.post('https://api.zasway.com:8443/Zone/Delete', id, {mode:'cors'})
   
//   await dispatch(getData(getState().zone.params))
  
//   return response
// })

export const ZoneSlice = createSlice({
   name: 'zone',
   initialState: {
     data: [],
     total: 1,
     params: {},
     allData: [],
     selectedUser: null,
     zoneEditData: [],
     postcodeZoneEditData: [],
     zoneCoordinates : null,
     zoneEditingCoordinatesSt: null,
     zoneCoordinatesAfterEdit: null,
     displayZoneCoordinatesSt: null,
     displayZoneCoordinatesStAll: null,
     modalclosedSt: null
   },
   reducers: {},
  extraReducers: builder => {
   builder
   .addCase(getZoneCoordinatesOnEdit.fulfilled, (state, action) => {
    
    state.zoneCoordinatesAfterEdit = action.payload.data
    }) 
    .addCase(modalClose.fulfilled, (state, action) => {
      
      state.modalclosedSt = action.payload.data
      state.zoneCoordinates = null
      state.zoneEditingCoordinatesSt = null 
      }) 
    
    .addCase(displayZoneCoordinates.fulfilled, (state, action) => {
      
      state.displayZoneCoordinatesSt = action.payload.data
      
      }) 

    .addCase(displayZoneCoordinatesAll.fulfilled, (state, action) => {

    state.displayZoneCoordinatesStAll = action.payload.data
    
    }) 

   .addCase(getEditZoneCoordinates.fulfilled, (state, action) => {
    
    state.zoneEditingCoordinatesSt = action.payload.data
   
    }) 
   .addCase(getZoneCoordinates.fulfilled, (state, action) => {
    
    
    state.zoneCoordinates = action.payload.data
   
    }) 
    
  .addCase(getZoneEditData.fulfilled, (state, action) => {
     
    state.zoneEditData = action.payload.data
  })

  .addCase(getPostcodeZoneEditData.fulfilled, (state, action) => {
     
    state.postcodeZoneEditData = action.payload.data
  })

  .addCase(getZoneTag.fulfilled, (state, action) => {
     
   state.data = action.payload.data
   state.params = action.payload.params
   state.allData = action.payload.allData
   state.total = action.payload.totalPages
 })
   .addCase(getData.fulfilled, (state, action) => {
      state.data = action.payload.data
      state.allData = action.payload.allData
      state.total = action.payload.totalPages 
      state.params = action.payload.params
  })
  .addCase(getZone.fulfilled, (state, action) => {
          
    state.selectedUser = action.payload.allData[0]
  })
   .addCase(resetZoneEditData.fulfilled, (state, action) => {
     
    state.exclusionTagEditData = action.payload.data
  })
  //  .addCase(resetZoneEditData.fulfilled, (state, action) => {
  //    
  //   state.exclusionTagEditData = action.payload.data
  // })
}
})

 export default ZoneSlice.reducer